import { withTranslation } from 'react-i18next';

import Payments from './Payments';

export default withTranslation()(Payments);
